<template>
  <div class="data-overview">
    <div class="overview-header">
      <h2>设备数据概览</h2>
      <el-button 
        type="primary" 
        size="small" 
        icon="el-icon-refresh" 
        @click="loadAllData"
        :loading="loading"
      >
        刷新数据
      </el-button>
    </div>

    <!-- 设备类型标签页 -->
    <el-tabs v-model="activeTab" @tab-click="handleTabClick" class="device-tabs" tab-position="left">
      <el-tab-pane label="车位锁" name="flatLock">
        <div class="tab-content">
          <!-- 统计卡片 -->
          <div class="statistics-cards">
      <div class="stat-card">
        <div class="stat-icon total">
          <i class="el-icon-s-data"></i>
        </div>
        <div class="stat-content">
          <div class="stat-number">{{ deviceStatistics.flatLock.total }}</div>
          <div class="stat-label">设备总数</div>
        </div>
      </div>

      <div class="stat-card">
        <div class="stat-icon online" style="background-color: #67C23A;">
          <i class="el-icon-success"></i>
        </div>
        <div class="stat-content">
          <div class="stat-number" style="color: #67C23A;">{{ deviceStatistics.flatLock.online }}</div>
          <div class="stat-label">在线设备</div>
        </div>
      </div>

      <div class="stat-card">
        <div class="stat-icon offline" style="background-color: #E6A23C;">
          <i class="el-icon-warning"></i>
        </div>
        <div class="stat-content">
          <div class="stat-number" style="color: #E6A23C;">{{ deviceStatistics.flatLock.offline }}</div>
          <div class="stat-label">离线设备</div>
        </div>
      </div>

      <div class="stat-card fault-card">
        <div class="stat-icon fault" style="background-color: #F56C6C;">
          <i class="el-icon-error"></i>
        </div>
        <div class="stat-content">
          <div class="stat-number" style="color: #F56C6C;">{{ deviceStatistics.flatLock.fault }}</div>
          <div class="stat-label">故障设备</div>
        </div>
      </div>

      <div class="stat-card two-column-card">
        <div class="stat-icon inUse" style="background-color: #E6A23C;">
          <i class="el-icon-lock"></i>
        </div>
        <div class="stat-content">
          <div class="stat-number" style="color: #E6A23C;">{{ deviceStatistics.flatLock.inUse }}</div>
          <div class="stat-label">使用中</div>
        </div>
      </div>

      <div class="stat-card two-column-card">
        <div class="stat-icon available" style="background-color: #67C23A;">
          <i class="el-icon-unlock"></i>
        </div>
        <div class="stat-content">
          <div class="stat-number" style="color: #67C23A;">{{ deviceStatistics.flatLock.available }}</div>
          <div class="stat-label">空闲中</div>
        </div>
      </div>

      <div class="stat-card abnormal-card" style="order: 7;">
        <div class="stat-icon flooded">
          <i class="el-icon-s-opportunity"></i>
        </div>
        <div class="stat-content">
          <div class="stat-number">{{ deviceStatistics.flatLock.flooded }}</div>
          <div class="stat-label">水淹设备</div>
        </div>
      </div>

      <div class="stat-card abnormal-card" style="order: 8;">
        <div class="stat-icon lowBattery">
          <i class="el-icon-battery"></i>
        </div>
        <div class="stat-content">
          <div class="stat-number">{{ deviceStatistics.flatLock.lowBattery }}</div>
          <div class="stat-label">电量过低设备</div>
        </div>
      </div>

      <div class="stat-card abnormal-card" style="order: 9;">
        <div class="stat-icon baffleAbnormal">
          <i class="el-icon-warning-outline"></i>
        </div>
        <div class="stat-content">
          <div class="stat-number">{{ deviceStatistics.flatLock.baffleAbnormal }}</div>
          <div class="stat-label">挡板异常设备</div>
        </div>
      </div>

      <div class="stat-card abnormal-card" style="order: 10;">
        <div class="stat-icon communicationAbnormal">
          <i class="el-icon-connection"></i>
        </div>
        <div class="stat-content">
          <div class="stat-number">{{ deviceStatistics.flatLock.communicationAbnormal }}</div>
          <div class="stat-label">通讯异常设备</div>
        </div>
      </div>
    </div>

    <!-- 图表区域 -->
    <div class="charts-container">
      <div class="chart-box">
        <div class="chart-title">设备状态分布</div>
        <div id="statusChart-flatLock" class="chart"></div>
      </div>

      <div class="chart-box">
        <div class="chart-title">设备使用情况</div>
        <div id="usageChart-flatLock" class="chart"></div>
      </div>
    </div>
        </div>
      </el-tab-pane>

      <el-tab-pane label="地磁" name="geomagnetism">
        <div class="tab-content">
          <!-- 统计卡片 -->
          <div class="statistics-cards">
            <div class="stat-card">
              <div class="stat-icon total">
                <i class="el-icon-s-data"></i>
              </div>
              <div class="stat-content">
                <div class="stat-number">{{ deviceStatistics.geomagnetism.total }}</div>
                <div class="stat-label">设备总数</div>
              </div>
            </div>

            <div class="stat-card">
              <div class="stat-icon online">
                <i class="el-icon-success"></i>
              </div>
              <div class="stat-content">
                <div class="stat-number">{{ deviceStatistics.geomagnetism.online }}</div>
                <div class="stat-label">在线设备</div>
              </div>
            </div>

            <div class="stat-card">
              <div class="stat-icon offline">
                <i class="el-icon-warning"></i>
              </div>
              <div class="stat-content">
                <div class="stat-number">{{ deviceStatistics.geomagnetism.offline }}</div>
                <div class="stat-label">离线设备</div>
              </div>
            </div>

            <div class="stat-card fault-card">
              <div class="stat-icon fault">
                <i class="el-icon-error"></i>
              </div>
              <div class="stat-content">
                <div class="stat-number">{{ deviceStatistics.geomagnetism.fault }}</div>
                <div class="stat-label">故障设备</div>
              </div>
            </div>

            <div class="stat-card two-column-card">
              <div class="stat-icon inUse">
                <i class="el-icon-lock"></i>
              </div>
              <div class="stat-content">
                <div class="stat-number">{{ deviceStatistics.geomagnetism.inUse }}</div>
                <div class="stat-label">使用中</div>
              </div>
            </div>

            <div class="stat-card two-column-card">
              <div class="stat-icon available">
                <i class="el-icon-unlock"></i>
              </div>
              <div class="stat-content">
                <div class="stat-number">{{ deviceStatistics.geomagnetism.available }}</div>
                <div class="stat-label">空闲中</div>
              </div>
            </div>

            <div class="stat-card abnormal-card" style="order: 7;">
              <div class="stat-icon lowBattery">
                <i class="el-icon-battery"></i>
              </div>
              <div class="stat-content">
                <div class="stat-number">{{ deviceStatistics.geomagnetism.lowBattery }}</div>
                <div class="stat-label">电量过低设备</div>
              </div>
            </div>

            <div class="stat-card abnormal-card" style="order: 8;">
              <div class="stat-icon communicationAbnormal">
                <i class="el-icon-connection"></i>
              </div>
              <div class="stat-content">
                <div class="stat-number">{{ deviceStatistics.geomagnetism.communicationAbnormal }}</div>
                <div class="stat-label">通讯异常设备</div>
              </div>
            </div>
          </div>

          <!-- 图表区域 -->
          <div class="charts-container">
            <div class="chart-box">
              <div class="chart-title">设备状态分布</div>
              <div id="statusChart-geomagnetism" class="chart"></div>
            </div>

            <div class="chart-box">
              <div class="chart-title">设备使用情况</div>
              <div id="usageChart-geomagnetism" class="chart"></div>
            </div>
          </div>
        </div>
      </el-tab-pane>

      <el-tab-pane label="巡检车" name="patrolCar">
        <div class="tab-content">
          <!-- 统计卡片 -->
          <div class="statistics-cards">
            <div class="stat-card">
              <div class="stat-icon total">
                <i class="el-icon-s-data"></i>
              </div>
              <div class="stat-content">
                <div class="stat-number">{{ deviceStatistics.patrolCar.total }}</div>
                <div class="stat-label">设备总数</div>
              </div>
            </div>

            <div class="stat-card">
              <div class="stat-icon online" style="background-color: #67C23A;">
                <i class="el-icon-success"></i>
              </div>
              <div class="stat-content">
                <div class="stat-number" style="color: #67C23A;">{{ deviceStatistics.patrolCar.online }}</div>
                <div class="stat-label">在线设备</div>
              </div>
            </div>

            <div class="stat-card">
              <div class="stat-icon offline" style="background-color: #E6A23C;">
                <i class="el-icon-warning"></i>
              </div>
              <div class="stat-content">
                <div class="stat-number" style="color: #E6A23C;">{{ deviceStatistics.patrolCar.offline }}</div>
                <div class="stat-label">离线设备</div>
              </div>
            </div>

            <div class="stat-card fault-card">
              <div class="stat-icon fault" style="background-color: #F56C6C;">
                <i class="el-icon-error"></i>
              </div>
              <div class="stat-content">
                <div class="stat-number" style="color: #F56C6C;">{{ deviceStatistics.patrolCar.fault }}</div>
                <div class="stat-label">故障设备</div>
              </div>
            </div>

            <div class="stat-card abnormal-card" style="order: 5;">
              <div class="stat-icon lowBattery">
                <i class="el-icon-battery"></i>
              </div>
              <div class="stat-content">
                <div class="stat-number">{{ deviceStatistics.patrolCar.lowBattery }}</div>
                <div class="stat-label">电量过低设备</div>
              </div>
            </div>

            <div class="stat-card abnormal-card" style="order: 6;">
              <div class="stat-icon communicationAbnormal">
                <i class="el-icon-connection"></i>
              </div>
              <div class="stat-content">
                <div class="stat-number">{{ deviceStatistics.patrolCar.communicationAbnormal }}</div>
                <div class="stat-label">通讯异常设备</div>
              </div>
            </div>
          </div>

          <!-- 图表区域 -->
          <div class="charts-container">
            <div class="chart-box">
               <div>功能开发中...</div>
              <!-- <div class="chart-title">设备状态分布</div>
              <div id="statusChart-patrolCar" class="chart"></div> -->
            </div>
          </div>
        </div>
      </el-tab-pane>

      <el-tab-pane label="高位视频" name="highVideo">
        <div class="tab-content">
          <!-- 统计卡片 -->
          <div class="statistics-cards">
            <div class="stat-card">
              <div class="stat-icon total">
                <i class="el-icon-s-data"></i>
              </div>
              <div class="stat-content">
                <div class="stat-number">{{ deviceStatistics.highVideo.total }}</div>
                <div class="stat-label">设备总数</div>
              </div>
            </div>

            <div class="stat-card">
              <div class="stat-icon online">
                <i class="el-icon-success"></i>
              </div>
              <div class="stat-content">
                <div class="stat-number">{{ deviceStatistics.highVideo.online }}</div>
                <div class="stat-label">在线设备</div>
              </div>
            </div>

            <div class="stat-card">
              <div class="stat-icon offline">
                <i class="el-icon-warning"></i>
              </div>
              <div class="stat-content">
                <div class="stat-number">{{ deviceStatistics.highVideo.offline }}</div>
                <div class="stat-label">离线设备</div>
              </div>
            </div>

            <div class="stat-card fault-card">
              <div class="stat-icon fault">
                <i class="el-icon-error"></i>
              </div>
              <div class="stat-content">
                <div class="stat-number">{{ deviceStatistics.highVideo.fault }}</div>
                <div class="stat-label">故障设备</div>
              </div>
            </div>

            <div class="stat-card abnormal-card" style="order: 5;">
              <div class="stat-icon communicationAbnormal">
                <i class="el-icon-connection"></i>
              </div>
              <div class="stat-content">
                <div class="stat-number">{{ deviceStatistics.highVideo.communicationAbnormal }}</div>
                <div class="stat-label">通讯异常设备</div>
              </div>
            </div>
          </div>

          <!-- 图表区域 -->
          <div class="charts-container">
            <div class="chart-box">
              <div>功能开发中...</div>
              <!-- <div class="chart-title">设备状态分布</div> -->
              <!-- <div id="statusChart-highVideo" class="chart"></div> -->
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>

    <!-- 详细信息表格 -->
    <!-- <div class="detail-section">
      <div class="section-title">设备详情</div>
      <el-table
        :data="tableData"
        border
        stripe
        v-loading="loading"
        style="width: 100%"
        :header-cell-style="{ background: '#f5f7fa', color: '#606266' }"
      >
        <el-table-column prop="lockId" label="锁记录号" width="120"></el-table-column>
        <el-table-column prop="lockSn" label="设备编号" width="150"></el-table-column>
        <el-table-column prop="gatewayId" label="网关编号" width="150"></el-table-column>
        <el-table-column prop="lockStatus" label="设备状态" width="100">
          <template slot-scope="scope">
            <el-tag 
              :type="getStatusType(scope.row.lockStatus).type"
              :style="{ backgroundColor: getStatusType(scope.row.lockStatus).color, borderColor: getStatusType(scope.row.lockStatus).color, color: '#fff' }"
              size="small"
            >
              {{ getStatusType(scope.row.lockStatus).text }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="parkingSpaceStatus" label="车位状态" width="100">
          <template slot-scope="scope">
            <el-tag 
              :type="getSpaceStatusType(scope.row.parkingSpaceStatus).type"
              :style="{ backgroundColor: getSpaceStatusType(scope.row.parkingSpaceStatus).color, borderColor: getSpaceStatusType(scope.row.parkingSpaceStatus).color, color: '#fff' }"
              size="small"
            >
              {{ getSpaceStatusType(scope.row.parkingSpaceStatus).text }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="voltage" label="电量" width="100"></el-table-column>
        <el-table-column prop="rssi" label="信号强度" width="100"></el-table-column>
        <el-table-column prop="finalTime" label="最后通信时间" width="180"></el-table-column>
        <el-table-column prop="alarm" label="告警" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.alarm" class="alarm-text">{{ scope.row.alarm }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="exception" label="异常信息" width="150">
          <template slot-scope="scope">
            <span v-if="scope.row.exception && scope.row.exception !== '正常'" class="exception-text">
              {{ scope.row.exception }}
            </span>
            <span v-else>-</span>
          </template>
        </el-table-column>
      </el-table>
      
      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
        ></el-pagination>
      </div>
    </div> -->
  </div>
</template>

<script>
import { 
  locks, 
  nbList, 
  patrolCarList, 
  requestIntellidataDeviceList 
} from "@/api/url";
import { echarts } from "@/utils/initEchart";

export default {
  name: "data-overview",
  data() {
    return {
      loading: false,
      activeTab: "flatLock", // 当前激活的标签页
      deviceStatistics: {
        flatLock: {
          total: 0,
          online: 0,
          offline: 0,
          fault: 0,
          inUse: 0,
          available: 0,
          flooded: 0,
          lowBattery: 0,
          baffleAbnormal: 0,
          communicationAbnormal: 0,
        },
        geomagnetism: {
          total: 0,
          online: 0,
          offline: 0,
          fault: 0,
          inUse: 0,
          available: 0,
          lowBattery: 0,
          communicationAbnormal: 0,
        },
        patrolCar: {
          total: 0,
          online: 0,
          offline: 0,
          fault: 0,
          lowBattery: 0,
          communicationAbnormal: 0,
        },
        highVideo: {
          total: 0,
          online: 0,
          offline: 0,
          fault: 0,
          communicationAbnormal: 0,
        },
      },
      tableData: [],
      charts: {}, // 存储各设备类型的图表实例
      pagination: {
        page: 1,
        pageSize: 20,
        total: 0,
      },
      allDevices: {
        flatLock: [],
        geomagnetism: [],
        patrolCar: [],
        highVideo: [],
      },
      hourlyUsageData: {
        flatLock: { hours: [], inUse: [], available: [] },
        geomagnetism: { hours: [], inUse: [], available: [] },
        patrolCar: { hours: [], inUse: [], available: [] },
        highVideo: { hours: [], inUse: [], available: [] },
      },
    };
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
    // 先初始化当前激活标签页的图表容器
    this.$nextTick(() => {
      this.initChartForDeviceType(this.activeTab);
    });
    // 然后加载数据
    this.loadAllData();
  },
  watch: {
    // 监听标签页切换
    activeTab(newVal) {
      this.$nextTick(() => {
        this.initChartForDeviceType(newVal);
        this.updateCharts(newVal);
      });
    },
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
    // 销毁所有图表
    Object.values(this.charts).forEach(chartGroup => {
      if (chartGroup.statusChart) {
        chartGroup.statusChart.dispose();
      }
      if (chartGroup.usageChart) {
        chartGroup.usageChart.dispose();
      }
    });
  },
  methods: {
    handleTabClick(tab) {
      // 切换标签页时，确保图表已初始化
      // watch 会自动处理，这里可以留空或添加额外逻辑
    },
    
    // 为特定设备类型初始化图表
    initChartForDeviceType(deviceType) {
      if (!deviceType) return;
      
      if (!this.charts[deviceType]) {
        this.charts[deviceType] = {};
      }
      
      // 初始化状态分布图表
      const statusChartDom = document.getElementById(`statusChart-${deviceType}`);
      if (statusChartDom) {
        // 如果图表已存在，先销毁
        if (this.charts[deviceType].statusChart) {
          this.charts[deviceType].statusChart.dispose();
        }
        this.charts[deviceType].statusChart = echarts.init(statusChartDom);
      }
      
      // 仅平板车位锁和地磁有使用情况图表
      if (deviceType === "flatLock" || deviceType === "geomagnetism") {
        const usageChartDom = document.getElementById(`usageChart-${deviceType}`);
        if (usageChartDom) {
          // 如果图表已存在，先销毁
          if (this.charts[deviceType].usageChart) {
            this.charts[deviceType].usageChart.dispose();
          }
          this.charts[deviceType].usageChart = echarts.init(usageChartDom);
        }
      }
    },
    
    // 加载所有设备类型的数据
    loadAllData() {
      this.loading = true;
      const params = {
        limit: 1000,
        page: 1,
      };
      
      // 并行加载所有设备类型的数据
      Promise.all([
        // 平板车位锁
        this.$postRequest(locks(), params).catch(err => ({ status: 500, data: { rows: [] }, message: err.message })),
        // 地磁
        this.$get(nbList(), params).catch(err => ({ status: 500, data: { rows: [] }, message: err.message })),
        // 巡检车
        this.$get(patrolCarList(), params).catch(err => ({ status: 500, data: { rows: [] }, message: err.message })),
        // 高位视频
        this.$get(requestIntellidataDeviceList(), params).catch(err => ({ status: 500, data: { rows: [] }, message: err.message })),
      ])
        .then(([flatLockRes, geomagnetismRes, patrolCarRes, highVideoRes]) => {
          // 处理平板车位锁数据
          if (flatLockRes.status === 200) {
            this.allDevices.flatLock = flatLockRes.data.rows || [];
            this.calculateStatistics("flatLock", this.allDevices.flatLock);
          }
          
          // 处理地磁数据
          if (geomagnetismRes.status === 200) {
            this.allDevices.geomagnetism = geomagnetismRes.data.rows || [];
            this.calculateStatistics("geomagnetism", this.allDevices.geomagnetism);
          }
          
          // 处理巡检车数据
          if (patrolCarRes.status === 200) {
            this.allDevices.patrolCar = patrolCarRes.data.rows || [];
            this.calculateStatistics("patrolCar", this.allDevices.patrolCar);
          }
          
          // 处理高位视频数据
          if (highVideoRes.status === 200) {
            this.allDevices.highVideo = highVideoRes.data.rows || [];
            this.calculateStatistics("highVideo", this.allDevices.highVideo);
          }
          
          this.$nextTick(() => {
            // 数据加载完成后，初始化当前激活标签页的图表并更新
            setTimeout(() => {
              // 确保当前标签页的图表已初始化
              this.initChartForDeviceType(this.activeTab);
              // 更新所有已初始化的图表
              this.updateAllCharts();
            }, 100);
          });
        })
        .catch((error) => {
          console.error("加载数据失败:", error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    calculateStatistics(deviceType, devices) {
      const stats = {
        total: devices.length,
        online: 0,
        offline: 0,
        fault: 0,
        inUse: 0,
        available: 0,
        flooded: 0,
        lowBattery: 0,
        baffleAbnormal: 0,
        communicationAbnormal: 0,
      };

      devices.forEach((device) => {
        // 根据设备类型适配不同的字段
        const deviceData = this.getDeviceData(device, deviceType);
        
        // 统计在线/离线状态
        const status = deviceData.status || "";
        if (status.includes("在线") || status === "在线" || status === "normal" || status === "正常") {
          stats.online++;
        } else if (status.includes("离线") || status === "离线" || status === "error" || status === "异常") {
          stats.offline++;
        }

        // 统计故障
        if (status.includes("故障") || deviceData.alarm || status === "error" || status === "异常") {
          stats.fault++;
        }

        // 统计使用情况（仅适用于平板车位锁和地磁）
        if (deviceType === "flatLock" || deviceType === "geomagnetism") {
          const spaceStatus = deviceData.spaceStatus || "";
          if (spaceStatus.includes("使用") || spaceStatus.includes("占用")) {
            stats.inUse++;
          } else if (spaceStatus.includes("空闲") || spaceStatus === "空闲") {
            stats.available++;
          }
        }

        // 统计水淹设备（仅适用于平板车位锁）
        if (deviceType === "flatLock") {
          const alarm = (deviceData.alarm || "").toString();
          const exception = (deviceData.exception || "").toString();
          if (
            alarm.includes("水淹") ||
            alarm.includes("水浸") ||
            exception.includes("水淹") ||
            exception.includes("水浸")
          ) {
            stats.flooded++;
          }
        }

        // 统计电量过低设备（适用于平板车位锁、地磁、巡检车）
        if (deviceType === "flatLock" || deviceType === "geomagnetism" || deviceType === "patrolCar") {
          const voltage = parseFloat(deviceData.voltage) || 0;
          const alarm = (deviceData.alarm || "").toString();
          const exception = (deviceData.exception || "").toString();
          const hasLowBatteryAlarm = 
            alarm.includes("电量") || 
            alarm.includes("低电量") || 
            alarm.includes("电池") ||
            alarm.includes("电压低") ||
            exception.includes("电量") ||
            exception.includes("低电量") ||
            exception.includes("电池") ||
            exception.includes("电压低");
          
          if (hasLowBatteryAlarm || (voltage > 0 && voltage < 3.2)) {
            stats.lowBattery++;
          }
        }

        // 统计挡板异常设备（仅适用于平板车位锁）
        if (deviceType === "flatLock") {
          const alarm = (deviceData.alarm || "").toString();
          const exception = (deviceData.exception || "").toString();
          if (
            alarm.includes("挡板") ||
            alarm.includes("板异常") ||
            alarm.includes("板故障") ||
            exception.includes("挡板") ||
            exception.includes("板异常") ||
            exception.includes("板故障")
          ) {
            stats.baffleAbnormal++;
          }
        }

        // 统计通讯异常设备
        const rssi = parseFloat(deviceData.rssi) || 0;
        const finalTime = deviceData.finalTime || deviceData.lastFlowDate || "";
        const alarm = (deviceData.alarm || "").toString();
        const exception = (deviceData.exception || "").toString();
        const hasCommunicationAlarm = 
          alarm.includes("通讯") || 
          alarm.includes("通信") || 
          alarm.includes("信号") ||
          alarm.includes("连接") ||
          exception.includes("通讯") ||
          exception.includes("通信") ||
          exception.includes("信号") ||
          exception.includes("连接");
        
        // 判断最后通信时间是否过长（超过30分钟）
        let isLongTimeNoCommunication = false;
        if (finalTime) {
          try {
            const lastCommTime = new Date(finalTime);
            const now = new Date();
            const diffMinutes = (now - lastCommTime) / (1000 * 60);
            // 超过30分钟未通信视为通讯异常
            if (diffMinutes > 30) {
              isLongTimeNoCommunication = true;
            }
          } catch (e) {
            // 如果时间格式解析失败，忽略
          }
        }
        
        if (hasCommunicationAlarm || (rssi < -110 && rssi !== 0) || isLongTimeNoCommunication) {
          stats.communicationAbnormal++;
        }
      });

      this.deviceStatistics[deviceType] = stats;
      this.calculateHourlyUsage(deviceType, devices);
    },
    
    // 根据设备类型获取统一的数据结构
    getDeviceData(device, deviceType) {
      switch (deviceType) {
        case "flatLock":
          // 平板车位锁
          return {
            status: device.lockStatus || "",
            alarm: device.alarm || "",
            exception: device.exception || "",
            spaceStatus: device.parkingSpaceStatus || "",
            voltage: device.voltage || 0,
            rssi: device.rssi || 0,
            finalTime: device.finalTime || "",
          };
        case "geomagnetism":
          // 地磁
          return {
            status: device.devStatus || device.attr1 || "",
            alarm: device.alarm || "",
            exception: device.exception || "",
            spaceStatus: device.parkingSpaceStatus || "",
            voltage: device.voltage || device.attr5 || 0,
            rssi: device.rssi || 0,
            finalTime: device.lastFlowDate || device.finalTime || "",
          };
        case "patrolCar":
          // 巡检车
          return {
            status: device.status || device.devStatus || "",
            alarm: device.alarm || "",
            exception: device.exception || "",
            spaceStatus: "",
            voltage: device.voltage || device.battery || 0,
            rssi: device.rssi || device.signal || 0,
            finalTime: device.lastTime || device.finalTime || "",
          };
        case "highVideo":
          // 高位视频
          return {
            status: device.status || device.devStatus || "",
            alarm: device.alarm || "",
            exception: device.exception || "",
            spaceStatus: "",
            voltage: 0,
            rssi: device.rssi || device.signal || 0,
            finalTime: device.lastTime || device.finalTime || "",
          };
        default:
          return {
            status: device.status || "",
            alarm: device.alarm || "",
            exception: device.exception || "",
            spaceStatus: device.parkingSpaceStatus || "",
            voltage: device.voltage || 0,
            rssi: device.rssi || 0,
            finalTime: device.finalTime || "",
          };
      }
    },

    calculateHourlyUsage(deviceType, devices) {
      // 初始化24小时数据
      const hours = [];
      const inUseData = [];
      const availableData = [];
      
      // 初始化每个小时的数据为0
      for (let i = 0; i < 24; i++) {
        hours.push(i + "时");
        inUseData.push(0);
        availableData.push(0);
      }

      // 获取当前小时
      const currentHour = new Date().getHours();
      
      // 根据当前数据统计每个小时的使用情况
      // 由于没有历史数据，我们根据当前状态和最后通信时间来估算
      // 仅统计平板车位锁和地磁的使用情况
      if (deviceType !== "flatLock" && deviceType !== "geomagnetism") {
        // 对于巡检车和高位视频，不统计使用情况
        this.hourlyUsageData[deviceType] = {
          hours,
          inUse: [],
          available: [],
        };
        return;
      }
      
      devices.forEach((device) => {
        const deviceData = this.getDeviceData(device, deviceType);
        const spaceStatus = deviceData.spaceStatus || "";
        const finalTime = deviceData.finalTime || "";
        
        let isInUse = false;
        if (spaceStatus.includes("使用") || spaceStatus.includes("占用")) {
          isInUse = true;
        }
        
        // 如果有最后通信时间，根据时间分布到对应小时
        if (finalTime) {
          try {
            const lastCommTime = new Date(finalTime);
            const hour = lastCommTime.getHours();
            
            // 如果是今天的数据，统计到对应小时
            const today = new Date();
            if (
              lastCommTime.getDate() === today.getDate() &&
              lastCommTime.getMonth() === today.getMonth() &&
              lastCommTime.getFullYear() === today.getFullYear()
            ) {
              if (isInUse) {
                inUseData[hour] = (inUseData[hour] || 0) + 1;
              } else {
                availableData[hour] = (availableData[hour] || 0) + 1;
              }
            }
          } catch (e) {
            // 如果时间解析失败，使用当前小时
            if (isInUse) {
              inUseData[currentHour] = (inUseData[currentHour] || 0) + 1;
            } else {
              availableData[currentHour] = (availableData[currentHour] || 0) + 1;
            }
          }
        } else {
          // 没有时间信息，使用当前小时
          if (isInUse) {
            inUseData[currentHour] = (inUseData[currentHour] || 0) + 1;
          } else {
            availableData[currentHour] = (availableData[currentHour] || 0) + 1;
          }
        }
      });

      // 如果没有数据，生成一些模拟数据用于展示
      if (devices.length === 0) {
        for (let i = 0; i < 24; i++) {
          // 模拟数据：白天使用率高，夜间空闲率高
          const hour = i;
          if (hour >= 8 && hour <= 20) {
            // 白天时段
            inUseData[i] = Math.floor(Math.random() * 30) + 20;
            availableData[i] = Math.floor(Math.random() * 20) + 10;
          } else {
            // 夜间时段
            inUseData[i] = Math.floor(Math.random() * 10) + 5;
            availableData[i] = Math.floor(Math.random() * 30) + 20;
          }
        }
      }

      this.hourlyUsageData[deviceType] = {
        hours,
        inUse: inUseData,
        available: availableData,
      };
    },

    loadTableData() {
      const start = (this.pagination.page - 1) * this.pagination.pageSize;
      const end = start + this.pagination.pageSize;
      this.tableData = this.allDevices[this.activeTab].slice(start, end);
    },

    initAllCharts() {
      // 初始化所有设备类型的图表
      const deviceTypes = ["flatLock", "geomagnetism", "patrolCar", "highVideo"];
      deviceTypes.forEach(type => {
        // 先初始化当前激活标签页的图表
        if (type === this.activeTab) {
          this.initChartForDeviceType(type);
        } else {
          // 对于非激活标签页，尝试初始化（如果DOM已存在）
          const statusChartDom = document.getElementById(`statusChart-${type}`);
          if (statusChartDom) {
            if (!this.charts[type]) {
              this.charts[type] = {};
            }
            // 如果图表已存在，先销毁再重新初始化
            if (this.charts[type].statusChart) {
              this.charts[type].statusChart.dispose();
            }
            this.charts[type].statusChart = echarts.init(statusChartDom);
          }

          // 仅平板车位锁和地磁有使用情况图表
          if (type === "flatLock" || type === "geomagnetism") {
            const usageChartDom = document.getElementById(`usageChart-${type}`);
            if (usageChartDom) {
              if (!this.charts[type]) {
                this.charts[type] = {};
              }
              // 如果图表已存在，先销毁再重新初始化
              if (this.charts[type].usageChart) {
                this.charts[type].usageChart.dispose();
              }
              this.charts[type].usageChart = echarts.init(usageChartDom);
            }
          }
        }
      });
    },

    updateAllCharts() {
      // 更新所有设备类型的图表
      Object.keys(this.charts).forEach(deviceType => {
        this.updateCharts(deviceType);
      });
    },

    updateCharts(deviceType) {
      deviceType = deviceType || this.activeTab;
      const chartGroup = this.charts[deviceType];
      const stats = this.deviceStatistics[deviceType];
      
      if (!chartGroup) {
        // 如果图表未初始化，尝试初始化
        this.initChartForDeviceType(deviceType);
        // 重新获取
        const newChartGroup = this.charts[deviceType];
        if (!newChartGroup || !stats) {
          return;
        }
        // 使用新初始化的图表组
        const statusChart = newChartGroup.statusChart;
        const usageChart = newChartGroup.usageChart;
        
        if (!statusChart) {
          return;
        }
        
        // 更新状态分布饼图
        const statusOption = this.getStatusChartOption(stats);
        statusChart.setOption(statusOption);
        
        // 更新使用情况柱状图（仅平板车位锁和地磁）
        if ((deviceType === "flatLock" || deviceType === "geomagnetism") && usageChart) {
          const usageData = this.hourlyUsageData[deviceType] || { hours: [], inUse: [], available: [] };
          const usageOption = this.getUsageChartOption(usageData);
          usageChart.setOption(usageOption);
        }
        return;
      }
      
      if (!stats) {
        return;
      }

      // 更新状态分布饼图
      const statusOption = this.getStatusChartOption(stats);
      
      if (chartGroup.statusChart) {
        chartGroup.statusChart.setOption(statusOption);
      }

      // 更新使用情况柱状图 - 24小时数据（仅平板车位锁和地磁）
      if ((deviceType === "flatLock" || deviceType === "geomagnetism") && chartGroup.usageChart) {
        const usageData = this.hourlyUsageData[deviceType] || { hours: [], inUse: [], available: [] };
        const usageOption = this.getUsageChartOption(usageData);
        chartGroup.usageChart.setOption(usageOption);
      }
    },
    
    // 获取状态分布图表配置
    getStatusChartOption(stats) {
      return {
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)",
          backgroundColor: "rgba(50, 50, 50, 0.9)",
          borderColor: "transparent",
          textStyle: {
            color: "#fff",
          },
        },
        legend: {
          orient: "vertical",
          left: "left",
          textStyle: {
            color: "#606266",
            fontSize: 14,
          },
        },
        color: [
          {
            type: "linear",
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              { offset: 0, color: "#3aa5ef" }, // 在线设备 - 智慧停车蓝色渐变
              { offset: 1, color: "#22aeff" },
            ],
          },
          {
            type: "linear",
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              { offset: 0, color: "#FFBA33" }, // 离线设备 - 智慧停车橙色渐变
              { offset: 1, color: "#ffc53d" },
            ],
          },
          {
            type: "linear",
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              { offset: 0, color: "#ff6b6b" }, // 故障设备 - 智慧停车红色渐变
              { offset: 1, color: "#ff8787" },
            ],
          },
        ],
        series: [
          {
            name: "设备状态",
            type: "pie",
            radius: ["40%", "70%"],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: "#fff",
              borderWidth: 2,
              shadowBlur: 10,
              shadowColor: "rgba(0, 0, 0, 0.1)",
            },
            label: {
              show: true,
              formatter: "{b}: {c}\n({d}%)",
              fontSize: 12,
              fontWeight: 500,
              color: "#303133",
            },
            labelLine: {
              show: true,
              length: 15,
              length2: 10,
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 20,
                shadowOffsetX: 0,
                shadowOffsetY: 0,
                shadowColor: "rgba(0, 0, 0, 0.2)",
              },
              label: {
                show: true,
                fontSize: 14,
                fontWeight: "bold",
              },
            },
            data: [
              { 
                value: stats.online, 
                name: "在线设备",
                itemStyle: {
                  color: {
                    type: "linear",
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                      { offset: 0, color: "#3aa5ef" }, // 智慧停车主题蓝色
                      { offset: 1, color: "#22aeff" },
                    ],
                  },
                },
              },
              { 
                value: stats.offline, 
                name: "离线设备",
                itemStyle: {
                  color: {
                    type: "linear",
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                      { offset: 0, color: "#FFBA33" }, // 智慧停车主题橙色
                      { offset: 1, color: "#ffc53d" },
                    ],
                  },
                },
              },
              { 
                value: stats.fault, 
                name: "故障设备",
                itemStyle: {
                  color: {
                    type: "linear",
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                      { offset: 0, color: "#ff6b6b" }, // 智慧停车主题红色
                      { offset: 1, color: "#ff8787" },
                    ],
                  },
                },
              },
            ],
          },
        ],
      };
      
      if (chartGroup.statusChart) {
        chartGroup.statusChart.setOption(statusOption);
      }

      // 更新使用情况柱状图 - 24小时数据（仅平板车位锁和地磁）
      if ((deviceType === "flatLock" || deviceType === "geomagnetism") && chartGroup.usageChart) {
        const usageData = this.hourlyUsageData[deviceType] || { hours: [], inUse: [], available: [] };
        const usageOption = this.getUsageChartOption(usageData);
        chartGroup.usageChart.setOption(usageOption);
      }
    },
    
    // 获取使用情况图表配置
    getUsageChartOption(usageData) {
      return {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
          backgroundColor: "rgba(50, 50, 50, 0.9)",
          borderColor: "transparent",
          textStyle: {
            color: "#fff",
          },
        },
        legend: {
          data: ["使用中", "空闲中"],
          top: 10,
          textStyle: {
            color: "#606266",
            fontSize: 12,
          },
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "8%",
          top: "15%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: usageData.hours,
          axisTick: {
            alignWithLabel: true,
          },
          axisLabel: {
            color: "#606266",
            fontSize: 11,
            interval: 1, // 显示所有小时标签
          },
          axisLine: {
            lineStyle: {
              color: "#E4E7ED",
            },
          },
        },
        yAxis: {
          type: "value",
          name: "设备数量",
          nameTextStyle: {
            color: "#606266",
            fontSize: 12,
          },
          axisLabel: {
            color: "#606266",
          },
          axisLine: {
            lineStyle: {
              color: "#E4E7ED",
            },
          },
          splitLine: {
            lineStyle: {
              color: "#F0F2F5",
              type: "dashed",
            },
          },
        },
        series: [
          {
            name: "使用中",
            type: "bar",
            data: usageData.inUse,
            itemStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  { offset: 0, color: "#3aa5ef" }, // 智慧停车蓝色
                  { offset: 1, color: "#22aeff" },
                ],
              },
              borderRadius: [4, 4, 0, 0],
            },
            barWidth: "35%",
          },
          {
            name: "空闲中",
            type: "bar",
            data: usageData.available,
            itemStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  { offset: 0, color: "#67C23A" }, // 绿色
                  { offset: 1, color: "#85ce61" },
                ],
              },
              borderRadius: [4, 4, 0, 0],
            },
            barWidth: "35%",
          },
        ],
      };
    },

    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.pagination.page = 1;
      this.loadTableData();
    },

    handleCurrentChange(val) {
      this.pagination.page = val;
      this.loadTableData();
    },

    // 获取设备状态类型和颜色
    getStatusType(status) {
      if (!status) return { type: "info", color: "#909399", text: "未知" };
      
      const statusStr = status.toString().toLowerCase();
      
      // 在线状态 - 绿色
      if (statusStr.includes("在线") || statusStr === "在线" || statusStr === "normal" || statusStr === "正常" || statusStr === "00" || statusStr === "01") {
        return { type: "success", color: "#67C23A", text: "在线" };
      }
      
      // 离线状态 - 橙色
      if (statusStr.includes("离线") || statusStr === "离线" || statusStr === "offline") {
        return { type: "warning", color: "#E6A23C", text: "离线" };
      }
      
      // 故障状态 - 红色
      if (statusStr.includes("故障") || statusStr === "故障" || statusStr === "error" || statusStr === "异常" || statusStr === "11") {
        return { type: "danger", color: "#F56C6C", text: "故障" };
      }
      
      // 待机状态 - 蓝色
      if (statusStr.includes("待机") || statusStr === "待机" || statusStr === "standby") {
        return { type: "info", color: "#409EFF", text: "待机" };
      }
      
      // 维护状态 - 灰色
      if (statusStr.includes("维护") || statusStr === "维护" || statusStr === "maintenance") {
        return { type: "info", color: "#909399", text: "维护" };
      }
      
      // 默认返回信息类型
      return { type: "info", color: "#909399", text: status };
    },

    // 获取车位状态类型和颜色
    getSpaceStatusType(status) {
      if (!status) return { type: "info", color: "#909399", text: "未知" };
      
      const statusStr = status.toString().toLowerCase();
      
      // 使用中/占用 - 橙色
      if (statusStr.includes("使用") || statusStr.includes("占用") || statusStr === "使用中" || statusStr === "占用" || statusStr === "occupied" || statusStr === "inuse") {
        return { type: "warning", color: "#E6A23C", text: "使用中" };
      }
      
      // 空闲 - 绿色
      if (statusStr.includes("空闲") || statusStr === "空闲" || statusStr === "空闲中" || statusStr === "available" || statusStr === "free") {
        return { type: "success", color: "#67C23A", text: "空闲" };
      }
      
      // 预约 - 蓝色
      if (statusStr.includes("预约") || statusStr === "预约" || statusStr === "reserved") {
        return { type: "info", color: "#409EFF", text: "预约" };
      }
      
      // 故障 - 红色
      if (statusStr.includes("故障") || statusStr === "故障" || statusStr === "error") {
        return { type: "danger", color: "#F56C6C", text: "故障" };
      }
      
      // 默认返回信息类型
      return { type: "info", color: "#909399", text: status };
    },

    handleResize() {
      // 调整所有图表大小
      Object.values(this.charts).forEach(chartGroup => {
        if (chartGroup.statusChart) {
          chartGroup.statusChart.resize();
        }
        if (chartGroup.usageChart) {
          chartGroup.usageChart.resize();
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.data-overview {
  padding: 20px;
  background-color: #f5f7fa;
  min-height: calc(100vh - 60px);
  display: flex;
  flex-direction: column;

  .overview-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    padding: 20px;
    background: white;
    border-radius: 4px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

    h2 {
      margin: 0;
      font-size: 24px;
      font-weight: 600;
      color: #303133;
    }
    
    .header-actions {
      display: flex;
      align-items: center;
    }
  }

  .device-tabs {
    background: white;
    border-radius: 4px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    height: calc(100vh - 180px);
    display: flex;

    ::v-deep .el-tabs__header {
      margin: 0;
      padding: 20px 0;
      border-right: 1px solid #e4e7ed;
      border-bottom: none;
      width: 150px;
      flex-shrink: 0;
    }

    ::v-deep .el-tabs__nav-wrap {
      &::after {
        display: none;
      }
    }

    ::v-deep .el-tabs__nav {
      width: 100%;
    }

    ::v-deep .el-tabs__item {
      width: 100%;
      text-align: left;
      padding: 0 20px;
      height: 50px;
      line-height: 50px;
      border-bottom: 1px solid #f0f0f0;
      
      &:last-child {
        border-bottom: none;
      }

      &.is-active {
        color: #409EFF;
        background-color: #ecf5ff;
        border-right: 2px solid #409EFF;
      }

      &:hover {
        color: #409EFF;
      }
    }

    ::v-deep .el-tabs__content {
      flex: 1;
      overflow: hidden;
      padding: 0;
    }

    ::v-deep .el-tab-pane {
      height: 100%;
      overflow: auto;
    }
    
    .tab-content {
      height: 100%;
      padding: 20px;
      box-sizing: border-box;
      overflow: auto;
    }
  }

  .statistics-cards {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;
    margin-bottom: 20px;

    .stat-card {
      display: flex;
      align-items: center;
      padding: 20px;
      background: white;
      border-radius: 4px;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
      transition: box-shadow 0.3s;

      &:nth-child(1) {
        order: 1;
      }

      &:nth-child(2) {
        order: 2;
      }

      &:nth-child(3) {
        order: 3;
      }

      &:nth-child(4) {
        order: 4;
      }

      &:nth-child(5) {
        order: 5;
      }

      &:nth-child(6) {
        order: 6;
      }

      &:nth-child(7) {
        order: 7;
      }

      &:nth-child(8) {
        order: 8;
      }

      &:nth-child(9) {
        order: 9;
      }

      &:nth-child(10) {
        order: 10;
      }

      &:hover {
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
      }

      .stat-icon {
        width: 60px;
        height: 60px;
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 15px;
        font-size: 28px;
        color: white;

        &.total {
          background-color: #409EFF;
        }

        &.online {
          background-color: #67C23A;
        }

        &.offline {
          background-color: #E6A23C;
        }

        &.fault {
          background-color: #F56C6C;
        }

        &.inUse {
          background-color: #909399;
        }

        &.available {
          background-color: #409EFF;
        }

        &.flooded {
          background-color: #409EFF;
          background: linear-gradient(135deg, #409EFF 0%, #1E90FF 100%);
        }

        &.lowBattery {
          background-color: #E6A23C;
        }

        &.baffleAbnormal {
          background-color: #F56C6C;
        }

        &.communicationAbnormal {
          background-color: #E6A23C;
        }
      }

      &.fault-card {
        order: 4;
      }

      &.two-column-card {
        grid-column: span 2;
      }

      .stat-content {
        flex: 1;

        .stat-number {
          font-size: 28px;
          font-weight: bold;
          color: #303133;
          margin-bottom: 5px;
        }

        .stat-label {
          font-size: 14px;
          color: #909399;
        }
      }
    }
  }

  .charts-container {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
    gap: 20px;
    margin-bottom: 20px;

    .chart-box {
      background: white;
      border-radius: 4px;
      padding: 20px;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

      .chart-title {
        font-size: 16px;
        font-weight: 600;
        color: #303133;
        margin-bottom: 15px;
        padding-bottom: 10px;
        border-bottom: 1px solid #EBEEF5;
      }

      .chart {
        width: 100%;
        height: 300px;
      }
    }
  }

  .detail-section {
    background: white;
    border-radius: 4px;
    padding: 20px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

    .section-title {
      font-size: 18px;
      font-weight: 600;
      color: #303133;
      margin-bottom: 15px;
      padding-bottom: 10px;
      border-bottom: 1px solid #EBEEF5;
    }

    .alarm-text {
      color: #F56C6C;
    }

    .exception-text {
      color: #E6A23C;
    }

    .pagination-container {
      margin-top: 20px;
      display: flex;
      justify-content: flex-end;
    }
  }
}

@media (max-width: 768px) {
  .data-overview {
    .statistics-cards {
      grid-template-columns: repeat(2, 1fr);
    }

    .charts-container {
      grid-template-columns: 1fr;
    }
  }
}
</style>
